import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { ClusterInputState } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
export const INPUT_STATES_QUERY_KEY = ["inputs", "states"];
export const fetchInputStates = async () => {
  const response = await ClusterInputState.get();
  const result = {};
  Object.keys(response).forEach((node) => {
    if (!response[node]) {
      return;
    }
    response[node].forEach((input) => {
      if (!result[input.id]) {
        result[input.id] = {};
      }
      result[input.id][node] = { ...input, state: input.state };
    });
  });
  return result;
};
const useInputsStates = ({ enabled } = { enabled: true }) => {
  const { data, refetch, isLoading } = useQuery({
    queryKey: INPUT_STATES_QUERY_KEY,
    queryFn: () => defaultOnError(
      fetchInputStates(),
      "Loading input states failed with status",
      "Could not load states types"
    ),
    placeholderData: keepPreviousData,
    refetchInterval: 2e3,
    retry: false,
    enabled
  });
  return { data, refetch, isLoading };
};
export default useInputsStates;
